import { JsonObject } from '../../helpers';
import { PrivateModelModel } from './private-model.model';

export type AwsPrivateModelConfig = {
  region: string;
};

// default to us-east-1 for now since it's the only region bedrock regularly works in
const DEFAULT_AWS_REGION = 'us-east-1';

export class AwsPrivateModelModel extends PrivateModelModel {
  config: AwsPrivateModelConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof PrivateModelModel, unknown>;

    this.provider = 'bedrock';

    this.config = (data.config as AwsPrivateModelConfig) || {
      region: DEFAULT_AWS_REGION,
    };
  }
}
